import React, { useState } from 'react'
import PropTypes from 'prop-types'

function LeaguePlugin({league, token, type, location_id}) {
  const [regType, setRegType] = useState(type || 'team')
  const regUrl = `/plugin/leagues/${league.id}/registrations/new?token=${token}&type=${regType}`
  const disableTeamReg = regType == 'team' && league.teams_space <= 0
  const disableIndReg = regType == 'individual' && league.players_space <= 0
  const disableReg = disableTeamReg || disableIndReg
  const currencyName = league.currency == 'usd' ? '' : ` (${league.currency.toUpperCase()})`

  const regClass = (type) => {
    return 'league-register-type' + (regType == type ? ' active' : '')
  }

  const changeRegistrationType = (type) => {
    if (regType == type) return

    setRegType(type)
  }

  const leagueName = league.full_name.toUpperCase()

  return <div className='row league-content'>
    <div className='col-xs-12 league-back'>
      <a href={`/plugin/leagues?token=${token}&location_id=${location_id}`}>&#10094;&nbsp;Back</a>
    </div>
    <div className='col-xs-12 league-name-small mobile-only'>{leagueName}</div>
    <div className='col-xs-12 col-md-4 league-image'>
      <img className='league-image' src={league.photo} />
    </div>
    <div className='col-xs-12 col-md-8 league-description'>
      <span className='league-name desktop-only'>{leagueName}</span>
      <div className='league-info'>
        <span>• Format:&nbsp;<span className='league-info__details'>{`${league.size_name} including goalie`}</span></span>
        <span>• Location:&nbsp;<span className='league-info__details'>{`${league.location}`}</span></span>
        <span>• Day:&nbsp;<span className='league-info__details'>{`${league.days}`}</span></span>
        <span>• Starts on:&nbsp;<span className='league-info__details'>{`${league.start_date}`}</span></span>
      </div>
      <div className='league-registration'>
        <div className={regClass('team')} onClick={() => changeRegistrationType('team')}>
          <span>Team</span>
          <span>{`Total${currencyName}: $${parseFloat(league.team_price).toFixed(2)}`}</span>
        </div>
        <div className={regClass('individual')} onClick={() => changeRegistrationType('individual')}>
          <span>Free Agent</span>
          <span>{`Total${currencyName}: $${parseFloat(league.individual_price).toFixed(2)}`}</span>
        </div>
      </div>
      <a href={regUrl} className={'league-button' + (disableReg ? ' disabled' : '')}>
        Register
      </a>
      <div className='league-information'>
        <div className='league-information__title'>INFO</div>
        <div className='league-information__about' dangerouslySetInnerHTML={{__html: league.about}}></div>
      </div>
    </div>
  </div>
}

LeaguePlugin.propTypes = {
  league: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
  type: PropTypes.string,
  location_id: PropTypes.number.isRequired,
}

export default LeaguePlugin
